import {
    BankOutlined,
    ContactsOutlined,
    FileOutlined,
    FilePdfFilled,
    FileTextOutlined, FileZipFilled,
    FolderOutlined,
    IdcardOutlined,
    MailFilled,
    PicRightOutlined,
    PictureFilled,
    PictureOutlined,
    PrinterFilled,
    PrinterOutlined,
    ReadOutlined,
    ShopOutlined,
    UserOutlined
} from "@ant-design/icons";


export const aodIconType = {

    // AOD items
    account: BankOutlined,
    advertiser: ShopOutlined,
    salesSheet: FolderOutlined,
    specAd: FileTextOutlined,
    publication: ReadOutlined,
    project: FolderOutlined,
    projectItem: FileOutlined,
    managedFile: FileOutlined,
    person: UserOutlined,
    campaign: FolderOutlined,
    order: FileTextOutlined,

    // Person roles
    contact: ContactsOutlined,
    salesRep: IdcardOutlined,
    service: UserOutlined,  // SS has a serviceBy - think it was complement to salesRep i.e. production user
    creator: UserOutlined,  // todo ? other entities can be owners

    // Person Owners
    accountPerson: UserOutlined,
    advertiserPerson: ContactsOutlined,

    // Aod type field
    SOLE_AD: FileTextOutlined,
    SALES_PRESENTATION: FolderOutlined,

    // MCC/MiAD assets
    template: PicRightOutlined,

    // Misc
    artwork: PictureOutlined,  //??

    // Share/Download Actions
    Print: PrinterFilled,
    Email: MailFilled,
    PDF: FilePdfFilled,
    JPEG: PictureFilled,
    'Production files': FileZipFilled,
    'Send production files': MailFilled,
    'Production file link': FileZipFilled,

    // todo
    // Buttons actions
};